"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.IntegrityChecker = void 0;
var _constants = require("./constants"),
  _kameleoonData = require("../kameleoonData"),
  _kameleoonError = require("../kameleoonError");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var IntegrityChecker = /*#__PURE__*/function () {
  function IntegrityChecker(a) {
    _classCallCheck(this, IntegrityChecker);
    _defineProperty(this, "key", void 0), this.key = a;
  }
  return _createClass(IntegrityChecker, [{
    key: "isDataValid",
    value: function isDataValid(a) {
      switch (this.key) {
        case _constants.KameleoonStorageKey.ClientData:
          return this.checkClientDataIntegrity(a);
        case _constants.KameleoonStorageKey.TargetingData:
          return this.checkTargetingDataIntegrity(a);
        case _constants.KameleoonStorageKey.DataInfo:
          return this.checkDataInfoIntegrity(a);
        case _constants.KameleoonStorageKey.VariationData:
          return this.checkVariationDataIntegrity(a);
        case _constants.KameleoonStorageKey.TrackingData:
          return this.checkTrackingDataIntegrity(a);
        default:
          return !0;
      }
    }
  }, {
    key: "getDefaultData",
    value: function getDefaultData() {
      switch (this.key) {
        case _constants.KameleoonStorageKey.ClientData:
          return this.getDefaultClientData();
        case _constants.KameleoonStorageKey.DataInfo:
          return {
            unsentData: {},
            nextVisitTime: 0,
            mappingIdentifiers: {}
          };
        case _constants.KameleoonStorageKey.TrackingData:
          return {
            scheduledVisitors: {}
          };
        case _constants.KameleoonStorageKey.TargetingData:
        case _constants.KameleoonStorageKey.VariationData:
        case _constants.KameleoonStorageKey.ConsentData:
          return {};
        case _constants.KameleoonStorageKey.VisitorCode:
          return "";
        case _constants.KameleoonStorageKey.KameleoonSimulationFFData:
          return "";
        case _constants.KameleoonStorageKey.ForcedExperimentVariation:
          return {};
        case _constants.KameleoonStorageKey.ForcedFeatureVariation:
          return {};
        default:
          (0, _kameleoonError.exhaustCheck)(this.key);
      }
    }
  }, {
    key: "checkTrackingDataIntegrity",
    value: function checkTrackingDataIntegrity(a) {
      return this.hasFields(a, ["scheduledVisitors"]);
    }
  }, {
    key: "checkDataInfoIntegrity",
    value: function checkDataInfoIntegrity(a) {
      return this.hasFields(a, ["unsentData", "nextVisitTime"]);
    }
  }, {
    key: "checkVariationDataIntegrity",
    value: function checkVariationDataIntegrity(a) {
      var _this = this;
      var b = Object.values(a);
      if (!b.length) return !0;
      var c = function c(a) {
        return !_this.hasFields(a, ["status"]) || _this.hasFields(a, ["isSent"]);
      };
      for (var _i = 0, _b = b; _i < _b.length; _i++) {
        var d = _b[_i];
        for (var _i2 = 0, _Object$values = Object.values(d); _i2 < _Object$values.length; _i2++) {
          var _a = _Object$values[_i2];
          if (c(_a)) return !1;
        }
      }
      return !0;
    }
  }, {
    key: "checkClientDataIntegrity",
    value: function checkClientDataIntegrity(a) {
      return this.hasFields(a, Object.keys(_constants.DEFAULT_CLIENT_CONFIGURATION));
    }
  }, {
    key: "checkTargetingDataIntegrity",
    value: function checkTargetingDataIntegrity(a) {
      var _this2 = this;
      var b = Object.values(a);
      if (!b.length) return !0;
      var _loop = function _loop() {
          var c = _b2[_i3];
          if ("string" == typeof c) return 0; // continue
          var a = function a(_a2) {
            return !_this2.hasFields(_a2, ["status"]) || _this2.hasFields(_a2, ["sent"]) || _this2.hasFields(_a2, ["timestampList"]);
          };
          for (var _i4 = 0, _Object$entries = Object.entries(c); _i4 < _Object$entries.length; _i4++) {
            var _ref = _Object$entries[_i4];
            var _ref2 = _slicedToArray(_ref, 2);
            var _b3 = _ref2[0];
            var d = _ref2[1];
            if (Array.isArray(d)) return {
              v: !1
            };
            switch (_b3) {
              case _kameleoonData.KameleoonData.PageView:
              case _kameleoonData.KameleoonData.Conversion:
              case _kameleoonData.KameleoonData.CustomData:
                {
                  var _b4 = Object.values(d).some(function (b) {
                    return a(b);
                  });
                  if (_b4) return {
                    v: !1
                  };
                  continue;
                }
              default:
                if (a(d)) return {
                  v: !1
                };
            }
          }
        },
        _ret;
      for (var _i3 = 0, _b2 = b; _i3 < _b2.length; _i3++) {
        _ret = _loop();
        if (_ret === 0) continue;
        if (_ret) return _ret.v;
      }
      return !0;
    }
  }, {
    key: "getDefaultClientData",
    value: function getDefaultClientData() {
      return _objectSpread(_objectSpread({}, _constants.DEFAULT_CLIENT_CONFIGURATION), {}, {
        lastUpdate: new Date().toString()
      });
    }
  }, {
    key: "hasFields",
    value: function hasFields(a, b) {
      var c = Object.keys(a);
      return !!(c.length && b.length) && b.every(function (a) {
        return c.includes(a);
      });
    }
  }]);
}();
exports.IntegrityChecker = IntegrityChecker;